var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { attrs: { id: "detail-wrap2" } }, [
    _c(
      "a",
      {
        staticClass: "close_btn",
        on: {
          click: function($event) {
            $event.preventDefault()
            return _vm.back($event)
          }
        }
      },
      [_vm._m(0)]
    ),
    _vm._v(" "),
    _c("div", { staticClass: "scroll_area" }, [
      _c("div", { staticClass: "head_data" }, [
        _vm._v(
          "\n      " +
            _vm._s(_vm.detail.id) +
            " - " +
            _vm._s(_vm.detail.surname) +
            " " +
            _vm._s(_vm.detail.name) +
            "（" +
            _vm._s(_vm.detail.surname_kana) +
            " " +
            _vm._s(_vm.detail.name_kana) +
            "）\n      "
        ),
        _c("span", { staticClass: "badge" }, [
          _vm._v(_vm._s(_vm.detail.contract_status_name))
        ])
      ]),
      _vm._v(" "),
      _vm.showChangeContract
        ? _c(
            "div",
            { staticClass: "text-right u-mb--15" },
            [
              _c(
                "el-button",
                {
                  attrs: { type: "primary", size: "small" },
                  on: { click: _vm.changeContract }
                },
                [_vm._v("信販から自社割賦へ変更")]
              )
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _c("table", { staticClass: "table table-bordered" }, [
        _c("tr", [
          _c("th", [_vm._v("会員番号")]),
          _vm._v(" "),
          _c("td", [_vm._v(_vm._s(_vm.detail.number))]),
          _vm._v(" "),
          _c("th", [_vm._v("承認番号")]),
          _vm._v(" "),
          _c("td", [_vm._v(_vm._s(_vm.detail.approval_number))])
        ]),
        _vm._v(" "),
        _c("tr", [
          _c("th", [_vm._v("申込日")]),
          _vm._v(" "),
          _c("td", [
            _vm._v(
              _vm._s(
                _vm._f("dateFormat")(_vm.detail.apply_date, "YYYY年MM月DD日")
              )
            )
          ]),
          _vm._v(" "),
          _c("th", [_vm._v("受付日")]),
          _vm._v(" "),
          _c("td", [
            _vm._v(
              _vm._s(
                _vm._f("dateFormat")(
                  _vm.detail.reception_date,
                  "YYYY年MM月DD日"
                )
              )
            )
          ])
        ]),
        _vm._v(" "),
        _c("tr", [
          _c("th", [_vm._v("申込金額")]),
          _vm._v(" "),
          _c("td", [_vm._v(_vm._s(_vm.detail.remaining_money_str))]),
          _vm._v(" "),
          _c("th", [_vm._v("状態")]),
          _vm._v(" "),
          _c("td", [_vm._v(_vm._s(_vm.detail.contract_status_name))])
        ]),
        _vm._v(" "),
        _c("tr", [
          _c("th", [_vm._v("キャンセル")]),
          _vm._v(" "),
          _c(
            "td",
            [
              _vm.isCancelable
                ? [
                    _c(
                      "el-button",
                      {
                        attrs: {
                          type: "danger",
                          size: "small",
                          disabled: !_vm.detail.can_cancel
                        },
                        on: { click: _vm.cancel }
                      },
                      [
                        _vm._v(
                          "\n              " +
                            _vm._s(
                              _vm.detail.cancel_status_name === ""
                                ? "キャンセル"
                                : _vm.detail.cancel_status_name
                            ) +
                            "\n            "
                        )
                      ]
                    ),
                    _vm._v(" "),
                    _vm.showCancelNotice(_vm.detail)
                      ? _c("span", { staticClass: "cancel_notice" }, [
                          _vm._v(
                            _vm._s(
                              _vm.dateFormat(_vm.detail.closing_date, "M月DD日")
                            ) + "(締日)まではキャンセル可能"
                          )
                        ])
                      : _vm._e()
                  ]
                : _vm._e()
            ],
            2
          ),
          _vm._v(" "),
          _c("th", [_vm._v("商品")]),
          _vm._v(" "),
          _c(
            "td",
            _vm._l(_vm.detail.products, function(product) {
              return _c(
                "span",
                { key: product.id },
                [
                  _vm._v(
                    "\n            " + _vm._s(product.name) + "\n            "
                  ),
                  product.product_other_name
                    ? [
                        _c("br"),
                        _vm._v(_vm._s(product.product_other_name) + " ")
                      ]
                    : _vm._e()
                ],
                2
              )
            }),
            0
          )
        ]),
        _vm._v(" "),
        _c("tr", [
          _c("th", [_vm._v("PDF")]),
          _vm._v(" "),
          _c("td", [
            _c(
              "a",
              {
                staticClass: "btn btn-primary btn-sm",
                attrs: { href: "/pdf/store/" + _vm.detail.id, target: "_blank" }
              },
              [_vm._v("お申込書控え")]
            )
          ]),
          _vm._v(" "),
          _c("th", [_vm._v("店舗")]),
          _vm._v(" "),
          _c("td", [_vm._v(_vm._s(_vm.detail.branch.name))])
        ]),
        _vm._v(" "),
        _c("tr", [
          _c("th", [_vm._v("契約情報")]),
          _vm._v(" "),
          _c(
            "td",
            { attrs: { colspan: "3" } },
            [
              _c(
                "el-button",
                {
                  attrs: { type: "primary", size: "small" },
                  on: { click: _vm.registPhoto }
                },
                [_vm._v("口座情報・写真追加")]
              ),
              _vm._v(" "),
              _c(
                "el-button",
                {
                  attrs: {
                    type: "primary",
                    size: "small",
                    disabled: !_vm.showUpdateBtn
                  },
                  on: { click: _vm.updateProduct }
                },
                [_vm._v("商品内容変更")]
              ),
              _vm._v(" "),
              _c(
                "el-button",
                {
                  attrs: {
                    type: "primary",
                    size: "small",
                    disabled: !_vm.showUpdateBtn
                  },
                  on: { click: _vm.updateCustomer }
                },
                [_vm._v("お客様情報変更")]
              ),
              _vm._v(" "),
              _vm.detail.contract_status_name === "承認"
                ? _c("span", [
                    _vm._v(
                      "「承認」後は変更不可ですので、チャットにてご連絡ください。"
                    )
                  ])
                : _vm._e()
            ],
            1
          )
        ])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "chat-area" }, [
        _c(
          "div",
          { staticClass: "message_area" },
          [
            _c("el-input", {
              attrs: {
                type: "textarea",
                rows: 3,
                placeholder: "チャットメッセージを入力"
              },
              model: {
                value: _vm.chatMessage,
                callback: function($$v) {
                  _vm.chatMessage = $$v
                },
                expression: "chatMessage"
              }
            }),
            _vm._v(" "),
            _vm.errors.message
              ? _c("p", { staticClass: "admin_form_error_message" }, [
                  _vm._v(_vm._s(_vm.errors.message))
                ])
              : _vm._e(),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "send_btn" },
              [
                _c(
                  "el-button",
                  {
                    attrs: { size: "mini", disabled: _vm.isMessageBtnPushed },
                    on: { click: _vm.addMessage }
                  },
                  [
                    _c("i", { staticClass: "el-icon-chat-line-round" }),
                    _vm._v(" 送信する\n          ")
                  ]
                )
              ],
              1
            )
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "messages" },
          _vm._l(_vm.chatList, function(row, index) {
            return _c("div", { key: index, staticClass: "message" }, [
              row.type == "COMPANY"
                ? _c(
                    "p",
                    { staticClass: "signature jcg" },
                    [
                      _c(
                        "el-checkbox",
                        {
                          on: {
                            change: function($event) {
                              return _vm.changeRead(row)
                            }
                          },
                          model: {
                            value: row.is_readed,
                            callback: function($$v) {
                              _vm.$set(row, "is_readed", $$v)
                            },
                            expression: "row.is_readed"
                          }
                        },
                        [
                          _vm._v(
                            _vm._s(row.account_name) +
                              " - " +
                              _vm._s(
                                _vm._f("dateFormat")(
                                  row.date,
                                  "YYYY.MM.DD HH:mm"
                                )
                              )
                          )
                        ]
                      )
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              row.type == "STORE" || row.type == "BRANCH"
                ? _c(
                    "p",
                    { staticClass: "signature store" },
                    [
                      row.is_readed
                        ? [
                            _c("span", { staticClass: "is_read" }, [
                              _vm._v("既読")
                            ])
                          ]
                        : _vm._e(),
                      _vm._v(
                        _vm._s(row.account_name) +
                          " - " +
                          _vm._s(
                            _vm._f("dateFormat")(row.date, "YYYY.MM.DD HH:mm")
                          ) +
                          "\n          "
                      )
                    ],
                    2
                  )
                : _vm._e(),
              _vm._v(" "),
              _c("p", { staticClass: "text" }, [_vm._v(_vm._s(row.message))])
            ])
          }),
          0
        )
      ])
    ])
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("span", [_c("i", { staticClass: "el-icon-close" })])
  }
]
render._withStripped = true

export { render, staticRenderFns }